import { render, staticRenderFns } from "./cnpc.vue?vue&type=template&id=9ded2322&scoped=true&"
import script from "./cnpc.vue?vue&type=script&lang=js&"
export * from "./cnpc.vue?vue&type=script&lang=js&"
import style0 from "./cnpc.vue?vue&type=style&index=0&id=9ded2322&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ded2322",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ContentType1: require('D:/Project/kpwebsite/PC/components/content/content-type-1.vue').default})
